import { mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants';
import LocationUtil from '@/util/location-util';
import hasAppDialog from '@/mixins/hasAppDialog';
import inGeofence from '@/mixins/location/inGeofence';
import hasLocationFeature from '@/mixins/location/hasLocationFeature';

export default {
  mixins: [hasAppDialog, inGeofence, hasLocationFeature],

  computed: {
    ...mapState({
      employeeId: (state) => state.employee.id,
    }),
    ...mapGetters(['getNoLocationDataRequired']),
  },

  methods: {
    ...mapMutations(['setNoLocationDataRequired']),

    getBaseTimeEntryRequest(
      entryType,
      timeZoneOffset,
      locationRequired,
      assignmentId,
      timeTypeId,
      then,
      lastly,
    ) {
      const delayInMilliseconds = entryType === constants.EntryType.CLOCK_OUT
        ? constants.CLOCK_OUT_DELAY_IN_MILLISECONDS
        : 0;

      const timeEntry = {
        latitude: -1,
        longitude: -1,
        accuracy: -1,
        geofenceResult: constants.LocationData.GeofenceResult.NO_GEOFENCE,
        entryType,
        timeZoneOffset: timeZoneOffset || new Date().getTimezoneOffset(),
        origin: 'UNKNOWN',
        requestedBy: {
          id: this.employeeId,
        },
        delayInMilliseconds,
      };

      if (timeTypeId) {
        timeEntry.timeTypeId = timeTypeId;
      }

      if (locationRequired && this.isLocationFeatureActive) {
        const successCallback = (locationData) => {
          if (locationData) {
            const geofenceResultData = this.getTimeEntryGeofenceResult(
              locationData,
              assignmentId,
            );
            this.setNoLocationDataRequired(false);
            then({
              ...timeEntry,
              ...locationData,
              geofenceResult: geofenceResultData.result
                ? geofenceResultData.result : constants.LocationData.GeofenceResult.NO_GEOFENCE,
              geofence: geofenceResultData.id ? geofenceResultData.id : null,
            });
          } else {
            then(timeEntry);
          }
        };
        const errorCallback = () => {
          if (!this.getNoLocationDataRequired()) {
            this.showAppConfirmDialog({
              message: this.$t('dialogs.confirm.noLocation'),
              confirmHandler: () => {
                this.setNoLocationDataRequired(true);
                successCallback();
              },
              cancelHandler: () => lastly(),
            });
          } else {
            successCallback();
          }
        };

        LocationUtil.retrievePosition(successCallback, errorCallback);
      } else {
        then(timeEntry);
      }
    },
  },

};
